import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create({
  spaceBetween: {
    justifyContent: 'space-between',
  },
  timeButton: {
    height: 48,
  },
});
